import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import InputText from 'components/InputText';
import InputSelect from 'components/InputSelect';
import InputData from 'components/InputDate';
import {
  fetchGetTodosSexos,
  fetchGetTodosEscolaridade,
  fetchGetTodosProfissao,
} from 'store/fetchActions/fetchInputForm';
import { cpfMask, telefoneMask } from 'utils/masks';
import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import moment from 'moment';

export default function FormPessoaFisica({
  control,
  onChange,
  errors,
  tipoPessoaSelecionada,
  disabled,
  getValues,
  verificarRepeticao,
  disableDocumento,
}) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const inputSelectOptionsSexo = useSelector(state => state.inputs.inputSelectOptionsSexo);
  const inputSelectOptionsEscolaridade = useSelector(state => state.inputs.inputSelectOptionsEscolaridade);
  const inputSelectOptionsProfissao = useSelector(state => state.inputs.inputSelectOptionsProfissao);

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosSexos(inputSelectOptionsSexo));
    dispatch(fetchGetTodosEscolaridade(inputSelectOptionsEscolaridade));
    dispatch(fetchGetTodosProfissao(inputSelectOptionsProfissao));
    // eslint-disable-next-line
  }, [dispatch, unitaryTests]);

  function disabledDate(current) {
    return current && current > moment().endOf('day');
  }

  return (
    <Row justify="start">
      <Col xs={24} sm={16} md={8} lg={8} xl={7}>
        <InputText
          label={
            tipoPessoaSelecionada === ENUM_TIPO_PESSOA.fisica.descricao
              ? '* Nome Completo'
              : '* Nome Completo Representante'
          }
          name="nome"
          errors={errors}
          placeholder={'Nome Completo'}
          control={control}
          onChange={onChange}
          maxLength={150}
          disabled={disabled}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={7}>
        <InputText
          label="Nome Social"
          name="nomeSocial"
          errors={errors}
          placeholder={'Nome Social (Lei Nº 7859/2010)'}
          control={control}
          onChange={onChange}
          maxLength={150}
          disabled={disabled}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={3}>
        <InputText
          label="* CPF"
          name="cpf"
          errors={errors}
          placeholder={'CPF'}
          control={control}
          onChange={e => {
            if (e.target.value.length === 14) verificarRepeticao?.(e.target.value);
            onChange({
              target: {
                name: 'cpf',
                value: cpfMask(e.target.value),
              },
            });
          }}
          maxLength={18}
          disabled={disabled || disableDocumento}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={4}>
        <InputData
          label="Data de Nascimento"
          name="dataNascimento"
          errors={errors}
          placeholder={'Data de Nascimento'}
          control={control}
          onChange={onChange}
          disabledDate={disabledDate}
          inputReadOnly={false}
          disabled={disabled}
          defaultValue={getValues('dataNascimento')}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={3}>
        <InputSelect
          label="Sexo"
          name="sexoId"
          placeholder={'Selecionar Sexo'}
          errors={errors}
          control={control}
          options={montarDadosInputSelect(inputSelectOptionsSexo, 'id', 'descricao')}
          disabled={disabled}
        />
      </Col>

      <Col xs={24} sm={16} md={8} lg={8} xl={5}>
        <InputText
          label="* E-mail"
          name="email"
          errors={errors}
          placeholder={'E-mail'}
          control={control}
          onChange={onChange}
          maxLength={100}
          disabled={disabled}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={4}>
        <InputText
          label="Telefone"
          name="telefone"
          errors={errors}
          placeholder={'Telefone'}
          control={control}
          onChange={e =>
            onChange({
              target: {
                name: 'telefone',
                value: telefoneMask(e.target.value),
              },
            })
          }
          maxLength={16}
          disabled={disabled}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={4}>
        <InputSelect
          label="Escolaridade"
          name="escolaridadeId"
          errors={errors}
          placeholder={'Selecionar Escolaridade'}
          control={control}
          options={montarDadosInputSelect(inputSelectOptionsEscolaridade, 'id', 'descricao')}
          disabled={disabled}
        />
      </Col>
      <Col xs={24} sm={16} md={8} lg={8} xl={4}>
        <InputSelect
          label="Profissão"
          name="profissaoId"
          errors={errors}
          placeholder={'Selecionar Profissão'}
          control={control}
          options={montarDadosInputSelect(inputSelectOptionsProfissao, 'id', 'descricao')}
          disabled={disabled}
        />
      </Col>
    </Row>
  );
}

FormPessoaFisica.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  tipoPessoaSelecionada: PropTypes.string,
  disabled: PropTypes.bool,
  getValues: PropTypes.func,
  verificarRepeticao: PropTypes.func,
};
